import { ReactNode, useEffect } from 'react';
import { inboxCallItemEventBus } from '@frontend/inbox-call-item-event-bus';
import { useMessageInsightsController } from '@frontend/message-insights-panel';

export const useInboxMessageItemEventListener = () => {
  const messageInsightsController = useMessageInsightsController({
    source: 'threadView',
  });

  useEffect(() => {
    const handleOpenMessageInsightsPanel = (data: {
      messageId: string;
      threadId: string;
      locationId: string;
      createdAt?: string;
      escalationSubject?: string;
      escalationBody?: string;
      outcomeBubbleNode?: ReactNode;
    }) => {
      messageInsightsController.open({
        messageId: data.messageId,
        threadId: data.threadId,
        locationId: data.locationId,
        createdAt: data.createdAt,
        escalationSubject: data.escalationSubject,
        escalationBody: data.escalationBody,
        outcomeBubbleNode: data.outcomeBubbleNode,
      });
    };

    // Subscribe to events
    inboxCallItemEventBus.on('openMessageInsightsPanel', handleOpenMessageInsightsPanel);

    // Cleanup on unmount
    return () => {
      inboxCallItemEventBus.off('openMessageInsightsPanel', handleOpenMessageInsightsPanel);
    };
  }, [messageInsightsController]);
};
